import { configureStore, applyMiddleware } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';

import propertiesReducer from './features/properties';
import unitsReducer from './features/units';
import tenantsReducer from './features/tenants';
import teamReducer from './features/team';
import landlordsReducer from './features/landlords';
import invoicesReducer from './features/invoices';
import paymentsReducer from './features/payments';
import expensesReducer from './features/expenses';
import optionsReducer from './features/options';
import BillingReducer from './features/billing';
import messagesReducer from './features/messages';
import messagesOrderReducer from './features/messages/order';
import messagesSummaryReducer from './features/messages/summary';
import userReducer from './features/user';
import settingsReducer from './features/settings';
import bankAccountsReducer from './features/bankAccount';

import {
    unitsMiddleware,
    propertiesMiddleware,
    tenantsMiddleware,
    landlordsMiddleware,
    optionsMiddleware,
    invoicesMiddleware,
    paymentsMiddleware,
    expensesMiddleware,
    transactionsMiddleware,
    billingMidddleware,
    messagesMiddleware,
    userMiddleware,
    settingsMiddleware,
    activityLogMiddleware,
    bankAccountsMiddleware,
    BankStatementMiddleware,
    mpesaMiddleware,
    currencyMiddleware,
    withdrawalsMiddleware,
    timezoneMiddleware,
    onBoardingMiddleware,
    surveyMiddleware,
    paystackMiddleware,
    notificationsMiddleware
} from './middleware'
import { bulkUploadMiddleware } from './middleware/bulk_upload';
import authorizationReducer from './features/authorization';
import finishedAuthCheckReducer from './features/authorization/finished_auth_check';
import { verifyTokenMiddleware } from './middleware/authorization';
import feedbackModalReducer from './features/feedback_modal';
import loadingIndicatorReducer from './features/loading_indicator';
import { teamMiddleware } from './middleware/team';
import { smsMiddleware } from './middleware/sms';
import invoicesOrderReducer from './features/invoices/invoicesOrder';
import paymentsOrderReducer from './features/payments/paymentsOrder';
import paymentsSummaryReducer from './features/payments/summary';
import expensesOrderReducer from './features/expenses/expensesOrder';
import expensesSummaryReducer from './features/expenses/summary';
import invoicesSummaryReducer from './features/invoices/summary';
import dashboardSummaryReducer from './features/dashboard_summary';
import { dashboardSummaryMiddleware } from './middleware/dashboard_summary';
import unitUtilitiesReducer from './features/unit_utilities';
import { unitUtilitiesMiddleware } from './middleware/unit_utilities';
import { reportsMiddleware } from './middleware/reports';
import preferencesReducer from './features/preferences';
import { preferencesMiddleware } from './middleware/preferences';
import { maintenancesMiddleware } from './middleware/maintenance';
import maintenancesReducer from './features/maintenance';
import maintenanceSummaryReducer from './features/maintenance/summary';
import maintenancesOrderReducer from './features/maintenance/order';
import { downloadMiddleware } from './middleware/download';
import unitsOrderReducer from './features/units/unitsOrder';
import tenantsOrderReducer from './features/tenants/tenantsOrder';
import activityLogsOrderReducer from './features/activityLog/activityLogsReducer';
import activityLogsReducer from './features/activityLog';
import { currencyReducer } from './features/currencies';
import withdrawalReducer from './features/withdrawals';
import { timezoneReducer } from './features/timezones';
import onBoardingReducer from './features/onBoarding';
import surveyReducer from './features/survey';
import { paystackReducer } from './features/paystack';
// Middlewares for tenantApp
import {tenantAuthMiddleware, tenantHomeMiddleware, tenantFinancialsMiddleware } from "./tenantApp/middleware"

//Reducers for tenantApp
import {tenantUserDetailsReducer, tenantPropertiesReducer, tenantHistoryReducer, tenantFinancialsReducer, tenantPaymentReducer} from './tenantApp/reducers/home';


const store = configureStore({
    reducer:{
        messagesSummary: messagesSummaryReducer,
        properties: propertiesReducer,
        units: unitsReducer,
        unitsOrder: unitsOrderReducer,
        tenants: tenantsReducer,
        landlords: landlordsReducer,
        tenantsOrder: tenantsOrderReducer,
        team: teamReducer,
        unitUtilities: unitUtilitiesReducer,
        user: userReducer, // Logged in user
        authorized: authorizationReducer,
        finishedAuthCheck: finishedAuthCheckReducer,
        invoices: invoicesReducer,
        invoicesOrder: invoicesOrderReducer,
        invoicesSummary: invoicesSummaryReducer,
        payments: paymentsReducer,
        paymentsOrder: paymentsOrderReducer,
        paymentsSummary: paymentsSummaryReducer,
        expenses: expensesReducer,
        expensesOrder: expensesOrderReducer,
        expensesSummary: expensesSummaryReducer,
        dashboardSummary: dashboardSummaryReducer,
        options: optionsReducer,
        feedbackModal: feedbackModalReducer,
        showLoading: loadingIndicatorReducer,
        preferences: preferencesReducer,
        maintenances: maintenancesReducer,
        maintenancesOrder: maintenancesOrderReducer,
        maintenanceSummary: maintenanceSummaryReducer,
        billing: BillingReducer,
        messages: messagesReducer,
        messagesOrder: messagesOrderReducer,
        settings: settingsReducer,
        activityLogs: activityLogsReducer,
        activityLogsOrder: activityLogsOrderReducer,
        bankAccounts: bankAccountsReducer,
        currency: currencyReducer,
        withdrawals: withdrawalReducer,
        timezone: timezoneReducer,
        onBoarding: onBoardingReducer,
        survey: surveyReducer,
        paystack: paystackReducer,
        // for tenantApp
        tenantUser: tenantUserDetailsReducer,
        tenantProperties: tenantPropertiesReducer,
        selectedProperty: tenantHistoryReducer,
        tenantFinancials: tenantFinancialsReducer,
        tenantPayment: tenantPaymentReducer,
    },
    preloadedState : {},
    middleware:  (getDefaultMiddleware) => { return [thunk, propertiesMiddleware, unitsMiddleware, tenantsMiddleware,
        invoicesMiddleware, paymentsMiddleware, expensesMiddleware,
        optionsMiddleware, teamMiddleware, bulkUploadMiddleware, verifyTokenMiddleware,
        unitUtilitiesMiddleware, smsMiddleware, reportsMiddleware, landlordsMiddleware,
        billingMidddleware, messagesMiddleware, userMiddleware,
        dashboardSummaryMiddleware, transactionsMiddleware, preferencesMiddleware,
        maintenancesMiddleware, settingsMiddleware, activityLogMiddleware, downloadMiddleware,
        bankAccountsMiddleware, BankStatementMiddleware, mpesaMiddleware, currencyMiddleware,
        withdrawalsMiddleware,
        timezoneMiddleware,
        onBoardingMiddleware,paystackMiddleware,
        surveyMiddleware,
        notificationsMiddleware,
        // for tenantApp
        tenantAuthMiddleware, tenantHomeMiddleware, tenantFinancialsMiddleware
    ]}
});

export default store;